import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

export function createSkipGlobalLoaderContext(): HttpContext {
  return new HttpContext().set(SKIP_GLOBAL_LOADER, true);
}

